import styled from 'styled-components'

export const CartContainer = styled.div`
  display: flex;
  height: 100%;
  overflow: auto;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  opacity: 0;
`;

export const CartButton = styled.button`
  display: flex;
  align-items: center;
  position: fixed;
  background-color: white;
  top: 2.2vw;
  right: 2vw;
  height: 2vw;
  font-size: 2vw;
  @media only screen and (max-width: 900px) {
    height: 6vw;
    font-size: 4vw;
  }
  z-index: 100;
  opacity: 0.6;
  transition: all 0.5s;
  &:hover:not(:disabled) {
    cursor: pointer;
    opacity: 1;
  }
  border-width: 0;
  > div {
    padding: 0.5vw 1vw
  }
  .loadingIcon {
    font-size: 2vw;
    @media only screen and (max-width: 900px) {
      font-size: 6vw;
    }
  }
`;

export const CloseButton = styled.button`
  position: fixed;
  top: 2.2vw;
  right: 2vw;
  width: 2vw;
  height: 2vw;
  font-size: 2vw;
  @media only screen and (max-width: 900px) {
    width: 6vw;
    height: 6vw;
    font-size: 6vw;
  }
  z-index: 101;
  cursor: pointer;
  opacity: 0.6;
  transition: all 0.5s;
  &:hover {
    opacity: 1;
  }
  background-color: transparent;
  border-width: 0;
`;

export const title = styled.h1`
  font-size: 4vw;
  @media only screen and (max-width: 900px) {
    font-size: 9vw;
  }
  &.mobileVersion {
    font-size: 9vw;
  }
  line-height: 1em;
  margin-top: 2vw;
  margin-bottom: 2vw;
`;

export const cartItem = styled.div`
  display: flex;
  align-items: flex-start;
  input {
    text-align: center;
  }

  @media only screen and (max-width: 900px) {
    flex-direction: column;
  }

  .itemImage {
    width: 25%;
    @media only screen and (max-width: 900px) {
      width: 100%;
    }

    > img {
      max-width: 150px;
      max-height: 150px;
    }
  }

  .itemDescription {
    width: 50%;
    @media only screen and (max-width: 900px) {
      width: 100%;
    }

    .itemName {
      font-weight: bold;
      margin-bottom: 0.5em;
    }
  }
  
  .itemQty {
    display: flex;
    align-items: center;

    @media only screen and (max-width: 900px) {
      padding-top: 1em;
    }
    
    .itemQtyButton {
      padding: 0 1em;
      cursor: pointer;
    }
  }

  .itemPrice {
    display: flex;
    flex-direction: column;
    
    width: 25%;
    text-align: right;
    font-weight: bold;

    .trash {
      padding: 0.5em 0;
      border: 0;
      background: none;
      text-align: right;
      cursor: pointer;
      width: 2em;

      &:hover {
        color: #8d0505;
      }
    }

    @media only screen and (max-width: 900px) {
      width: 100%;
      flex-direction: column-reverse;
      align-items: flex-end;
      position: relative;
      top: -3em;
    }
  }

  padding: 2em;
  @media only screen and (max-width: 900px) {
    padding: 2em 2em 0 2em;
  }

  &:not(:last-child) {
    border-color: #d2d2d2;
    border-style: solid;
    border-width: 0 0 1px 0;
  }
`;

export const cartTotal = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 calc(2vw + 2rem);
  .totalContainer {
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 1.4em;
    > div:first-child {
      padding-right: 2em;
    }
  }
`;

export const checkoutContainer = styled.div`
  padding: 2em calc(2vw + 2rem);
  display: flex;
  justify-content: flex-end;
  @media only screen and (max-width: 900px) {
    > button {
      width: 100%;
    }
  }
`;

export const checkoutButton = styled.button`
  background-color: rgba(0, 0, 0, 1);
  color: white;
  border-width: 0;
  padding: 1.5em 2.5em;
  cursor: pointer;
  &:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }
  &:disabled {
    background-color: rgba(0, 0, 0, 0.6) !important;
    cursor: default !important;
    opacity: 0.6;
  }
  .checkoutLoadingIcon {
    margin-right: 1em;
    font-size: 1.2em;
  }
`;
